type ContentAreaItem<T> = {
  ContentLink?: {
    Expanded?: T | null;
  } | null;
} | null;

export function isDefined<T>(value: T | null | undefined): value is T {
  return value != null;
}

export function getExpandedContentBlocks<T extends { __typename: string }>(
  items: Array<ContentAreaItem<T>> | null | undefined,
): T[] {
  return (
    items?.map((item) => item?.ContentLink?.Expanded).filter(isDefined) ?? []
  );
}

export function hasTypename<
  T extends { __typename: string },
  TTypename extends T["__typename"],
>(typename: TTypename) {
  return (value: T): value is Extract<T, { __typename: TTypename }> => {
    return value.__typename === typename;
  };
}
